import log from 'loglevel'
import axios, { type AxiosHeaders } from 'axios'
import { isNil } from 'lodash/fp'

import { url, getCustomHeaders } from 'components/DataProvider/functions'
import { assign } from 'lodash'
import { type Partner } from '@mzc-watchover/adminapp-appsync'

log.setLevel(log.levels.DEBUG)

export const doDownload = async (
  partner: Partial<Partner> | undefined,
  editCriterion: boolean,
  changeContact: boolean
): Promise<number | undefined> => {
  if (isNil(url)) return undefined
  const customHeaders = getCustomHeaders(
    {},
    !isNil(partner) ? partner.id : undefined
  ) as AxiosHeaders | undefined
  if (isNil(customHeaders)) return undefined
  const headers = {
    Authorization: customHeaders.get('Authorization')
  }
  if (!isNil(partner)) {
    assign(headers, { 'X-Partner': partner.id })
  }
  const { status } = await axios
    .post(
      `${url}/users/download`,
      { editCriterion, changeContact },
      {
        headers
      }
    )
    .catch((error) => error)
  return status
}
export const doCognitoDownload = async (): Promise<number | undefined> => {
  if (isNil(url)) return undefined
  const headers = getCustomHeaders({}, undefined) as AxiosHeaders | undefined
  if (isNil(headers)) return undefined
  const { status } = await axios
    .post(
      `${url}/cognito/users/download`,
      {},
      {
        headers: { Authorization: headers.get('Authorization') }
      }
    )
    .catch((error) => error)
  return status
}
export const doSummaryDownload = async (
  partner: string,
  item: string
): Promise<number | undefined> => {
  if (isNil(url)) return undefined
  const headers = getCustomHeaders({}, partner) as AxiosHeaders | undefined
  if (isNil(headers)) return undefined
  const { status } = await axios
    .post(
      `${url}/summary`,
      { item },
      {
        headers: { Authorization: headers.get('Authorization') }
      }
    )
    .catch((error) => error)
  return status
}
export const doOrganizationsDownload = async (
  partner: Partial<Partner> | undefined
): Promise<number | undefined> => {
  if (isNil(url)) return undefined
  const customHeaders = getCustomHeaders(
    {},
    !isNil(partner) ? partner.id : undefined
  ) as AxiosHeaders | undefined
  if (isNil(customHeaders)) return undefined
  const headers = {
    Authorization: customHeaders.get('Authorization')
  }
  if (!isNil(partner)) {
    assign(headers, { 'X-Partner': partner.id })
  }
  const { status } = await axios
    .post(
      `${url}/organizations/download`,
      {},
      {
        headers
      }
    )
    .catch((error) => error)
  return status
}
export const doAccountsDownload = async (
  partner: Partial<Partner> | undefined
): Promise<number | undefined> => {
  if (isNil(url)) return undefined
  const customHeaders = getCustomHeaders(
    {},
    !isNil(partner) ? partner.id : undefined
  ) as AxiosHeaders | undefined
  if (isNil(customHeaders)) return undefined
  const headers = {
    Authorization: customHeaders.get('Authorization')
  }
  if (!isNil(partner)) {
    assign(headers, { 'X-Partner': partner.id })
  }
  const { status } = await axios
    .post(
      `${url}/cognito/users/download`,
      {},
      {
        headers
      }
    )
    .catch((error) => error)
  return status
}
export const doContactListDownload = async (
  partner: Partial<Partner> | undefined
): Promise<number | undefined> => {
  if (isNil(url)) return undefined
  const customHeaders = getCustomHeaders(
    {},
    !isNil(partner) ? partner.id : undefined
  ) as AxiosHeaders | undefined
  if (isNil(customHeaders)) return undefined
  const headers = {
    Authorization: customHeaders.get('Authorization')
  }
  if (!isNil(partner)) {
    assign(headers, { 'X-Partner': partner.id })
  }
  const { status } = await axios.post(
    `${url}/contact/download`,
    {},
    {
      headers
    }
  )
  return status
}
